import React from 'react';
import { WorkersHeader } from '../components/WorkersHeader';
import { WorkersTable } from '../components/WorkersTable';
import { ProjectFilterPills } from '../components/ProjectFilterPills';
import { useProjectFilter, AVAILABLE_PROJECTS } from '../contexts/ProjectFilterContext';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function WorkersPage() {
  const {
    selectedProjects
  } = useProjectFilter();
  const getProjectDisplayText = () => {
    if (selectedProjects.length === AVAILABLE_PROJECTS.length) {
      return 'All Sites';
    }
    if (selectedProjects.length === 1) {
      return selectedProjects[0];
    }
    return `${selectedProjects.length} Sites`;
  };
  return <div className="min-h-screen bg-[#fafafa] font-sans relative" data-id="element-4533" data-mp="3owc7p96t214g">
      <main className="p-6 max-w-[1600px] mx-auto pb-24" data-id="element-4534" data-mp="3171fig3itf1x">
        <div className="mb-6" data-id="element-4535" data-mp="315gkkpdanu3j">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-4 transition-colors" data-id="element-4536" data-mp="2w8q4i21hoyi4">
            <ArrowLeft size={16} data-id="element-4537" data-mp="1chj3dqfc196y" />
            Back to Dashboard
          </Link>
          <div className="flex items-center gap-2" data-id="element-4538" data-mp="1hh5he22zitgt">
            <h1 className="text-3xl font-bold text-gray-900" data-id="element-4539" data-mp="1m9opwkmteyer">Workers</h1>
            <span className="text-gray-400 text-2xl" data-id="element-4540" data-mp="1mbsvd70d45h5">·</span>
            <span className="text-gray-600 text-xl" data-id="element-4541" data-mp="1r787nuiq1tbg">
              {getProjectDisplayText()}
            </span>
          </div>
          <ProjectFilterPills data-id="element-4542" data-mp="tmvpk3dc815a" />
        </div>

        <WorkersHeader data-id="element-4543" data-mp="yjcev0w9wljy" />
        <WorkersTable data-id="element-4544" data-mp="yknhgxdzfn9h" />
      </main>
    </div>;
}